import { Divider, Popover, Space, Tag, Tooltip } from "antd";
import { ReactNode } from "react";
import Icon from "../../../assets/icons/icon";
import { IconNames } from "../../../assets/icons/icon-list";
import CopyableContent from "../../../components/copyableContent";
import StatusTag from "../../../components/statusTag";
import { useTaxLegalCase } from "../../../contexts/taxLegalCaseStore";
import { useTaxLegalStages } from "../../../contexts/TaxLegalStagesStore";
import _t from "../../../lang/translate";
import format from "../../../utilities/formatNumbers";
import { normalizeCompanyName } from "../../../utilities/stringExtraFunctions";

export default function TaxLegalHeadKeyFields() {
  const taxLegalCase = useTaxLegalCase();

  return (

    <Space wrap style={{ rowGap: 0, marginTop: 4 }} size={"middle"}>
      <FieldItem label={taxLegalCase?.originalEvaluation?.reporterCompany ?? "-"} iconName="buildings" value={normalizeCompanyName(taxLegalCase?.originalEvaluation?.reporterCompany ?? "")} tooltip={_t("selfReporter")} />
      <FieldItem label={taxLegalCase.caseHandler?.fullName ?? "-"} iconName="person-outline" value={taxLegalCase.caseHandler?.fullName ?? ""} tooltip={_t("caseHandler")} />
      <GovernmentCaseIds />
      <Divider type="vertical" className="mr-0 ml-0" />
      <FieldItem label={<span className="text-medium text-danger">{format.date(taxLegalCase.nextDeadline)}</span>} iconName="warning-outline" value={format.date(taxLegalCase.nextDeadline)} tooltip={_t("next", "deadline")} />
      <FieldItem label={<StatusTag size="small" status={taxLegalCase.penaltyType} />} iconName="hand" value={taxLegalCase.penaltyType?.title ?? ""} tooltip={_t("responsibilityEvaluation")} />
    </Space>
  )
}


type FieldItemProps = {
  iconName: IconNames;
  label: ReactNode;
  value: string;
  tooltip?: string
}
function FieldItem({ value, label, iconName, tooltip }: FieldItemProps) {

  return (
    <Space size={"small"}>
      <Tooltip title={tooltip}>
        <Icon name={iconName} />
      </Tooltip>
      <CopyableContent className="text-medium" contentToCopy={value}>
        {label}
      </CopyableContent>
    </Space>

  )
}


function GovernmentCaseIds() {
  const { activeStageValues } = useTaxLegalCase()
  const governmentCaseNumber = activeStageValues?.governmentCaseNumber
  const governmentCaseIds = governmentCaseNumber?.split(',')
    .filter(Boolean);

  if (governmentCaseIds && governmentCaseIds?.length > 1) {
    const [first, ...rest] = governmentCaseIds
    return (
      <Space size="small">
        <FieldItem iconName="scroll" value={first ?? ""} label={first} />
        <Popover title={"Journal numre"} content={
          <Space direction="vertical">
            {rest.map(id => (
              <FieldItem key={id} iconName="scroll" value={id ?? ""} label={id} />
            ))}
          </Space>
        }>
          <Tag className="ant-tag-exception">+{rest.length}</Tag>
        </Popover>
      </Space>
    )
  }

  return (
    <FieldItem iconName="scroll" value={governmentCaseIds?.[0] ?? ""} label={governmentCaseIds?.[0]} />
  )
}
